import { render } from "./expertAvailability.vue?vue&type=template&id=5d96ddf6&ts=true"
import script from "./expertAvailability.vue?vue&type=script&lang=ts"
export * from "./expertAvailability.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__